import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import axios from "axios";
import ApiConfig from "../../config/ApiConfig";
import Tables from "../tables/Tables";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  Block,
  Delete,
  Edit,
  FileCopy,
  Search,
  Visibility,
} from "@material-ui/icons";
import moment from "moment";
import Widget from "../../components/Widget/Widget";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { UserContext } from "../../context/User";
import { styled } from "styled-components";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import CircularProgressWithBackdrop from "../../components/Loader/loader";

const useStyles = makeStyles({
  btn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "#00d4ff",
  },
  btn1: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "#00d4ff",
    marginTop: "21px",
  },
  btnGroup: {
    background: "white",
    boxShadow:
      "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
  },
  forminput: {
    "& .textFeilds": {
      border: "1.16355px solid #fff",
      borderRadius: "3.49065px !important",
    },
    "& .limitTextField": {
      width: "100%",
      maxWidth: "100px",
      border: "1.16355px solid #fff",
      borderRadius: "3.49065px !important",
      alignSelf: "end",
      marginRight: "9px",
    },
    "& .MuiSelect-icon": {},
  },
  forminputDate: {
    width: "100%",
    "& .MuiFormControl-marginDense": {
      border: "1.16355px solid #fff",
      borderRadius: "3.49065px !important",
      width: "100%",
    },
    "& .MuiInputBase-input": {},
  },
  FromTable1: {
    date: {
      color: "#004AAD",
    },
  },
});

const Title = styled.h1`
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Para = styled.p`
  color: black;
  font-size: 16px;
  padding-left: 7px;
  font-weight: 500;
`;
const OuterDiv = styled.div`
  padding: 1rem 5rem;
`;
const BtnDivision = styled.div`
  float: center;
  display: flex;
  margin-top: 1rem;
  justify-content: space-around;
`;

const BackBtn = styled.button`
  color: #000;
  background: #2ff3ff;
  padding: 7px 32px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
`;

function BranchHeadManagement() {
  const ContextId = useContext(UserContext);
  const classes = useStyles();
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [fromDate, setfromDate] = useState(null);
  const [toDate, settoDate] = useState(null);
  const values = localStorage.getItem("userId");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [status, setStatus] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const epochFrom = new Date(fromDate);
  const epochTo = new Date(toDate);
  epochFrom.setHours(0, 0, 0, 0);
  epochTo.setHours(23, 59, 59, 599);
  const [deleteID, setDeleteID] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [userStatus, setUserStatus] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [size, setSize] = useState();
  const [loader, setLoader] = useState(false);
  const [description, setDescription] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const handleCloseDialog = () => {
    setDeleteOpen(false);
  };
  const handleInputChange = (event) => {
    setSearchValue(event.target.value);
  };
  function TruncatedText({ text, maxLength }) {
    const truncatedText =
      text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const handleCopy = () => {
      navigator.clipboard.writeText(text);
      toast.success("Data copied to clipboard!");
    };

    return (
      <Tooltip title={text?.length > maxLength ? text : ""} placement="top">
        <span
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          {truncatedText}{" "}
          <FileCopy
            onClick={handleCopy}
            style={{ marginLeft: 4, color: "blue", width: "16px" }}
          />
        </span>
      </Tooltip>
    );
  }
  function TruncatedTextNormal({ text, maxLength }) {
    const truncatedText =
      text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const handleCopy = () => {
      navigator.clipboard.writeText(text);
      toast.success("Data copied to clipboard!");
    };

    return (
      <Tooltip title={text?.length > maxLength ? text : ""} placement="top">
        <span style={{ whiteSpace: "nowrap" }}>{truncatedText}</span>
      </Tooltip>
    );
  }
  const column = [
    {
      name: "serialNumber", // Custom column name
      label: "Sr.No.", // Column header label
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          // Calculate the serial number based on the row index
          const rowIndex = page * pageSize + tableMeta.rowIndex + 1;
          return rowIndex;
        },
      },
    },
    {
      name: "userId",
      options: {
        display: false,
      },
    },
    {
      name: "fullName",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <TruncatedTextNormal text={value} maxLength={20} />
            </>
          );
        },
      },
    },
    {
      label: "Email",
      name: "email",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <TruncatedText text={value} maxLength={20} />
            </>
          );
        },
      },
    },
    {
      name: "phoneNo",
      label: "Phone No.",
      options: {
        filter: false,
      },
    },
    {
      name: "createTime",
      label: "Created At",
      options: {
        filter: true,
        empty: true,

        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Typography style={{ whiteSpace: "nowrap" }}>
                {new Date(value).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: "state",
      label: "State",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "city",
      label: "City",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "block",
      label: "Block",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <TruncatedTextNormal text={value} maxLength={20} />
            </>
          );
        },
      },
    },
    {
      name: "userStatus",
      label: "User Status",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Actions / View",
      options: {
        filter: true,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", gap: "10px" }}>
              <IconButton
                onClick={(e) => {
                  history.push("/app/branch-head-management/view-head-details");
                  ContextId.handleContentId(tableMeta.rowData[1]);
                }}
              >
                <Visibility style={{ color: "blue" }} />{" "}
              </IconButton>

              <IconButton
                onClick={(e) => {
                  history.push("/app/update-user");
                  ContextId.handleContentId(tableMeta.rowData[1]);
                }}
              >
                <Edit style={{ color: "black" }} />{" "}
              </IconButton>

              <IconButton
                onClick={(e) => {
                  setDeleteID(tableMeta.rowData[1]);
                  setDeleteOpen(true);
                  if (tableMeta.rowData[9] === "ACTIVE") {
                    setUserStatus("BLOCK");
                  } else if (tableMeta.rowData[9] === "BLOCK") {
                    setUserStatus("ACTIVE");
                  }
                }}
              >
                {tableMeta.rowData[9] === "ACTIVE" ? (
                  <Block style={{ color: "red" }} />
                ) : (
                  <Block style={{ color: "green" }} />
                )}
              </IconButton>
              <IconButton
                onClick={(e) => {
                  setDeleteID(tableMeta.rowData[1]);
                  setDeleteDialog(true);
                }}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const UserByBH = async () => {
    setLoader(true);
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.filterBranchHeadDetails,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          BranchManagerId: values,
          page: page,
          pageSize: pageSize,
          searchByusernameorlocation: searchValue,
          fromDate: fromDate ? epochFrom.getTime() : null,
          toDate: toDate ? epochTo.getTime() : null,
          status: status,
        },
      });

      if (res.data.status === 200) {
        setSize(res?.data?.data?.totalCount);
        setLoader(false);
        setTableData(res?.data?.data?.list);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const userBlock = async (value) => {
    setIsLoading(true);
    try {
      const res = await axios({
        method: "PUT",
        url: ApiConfig.blockUnblock,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          userId: window.localStorage.getItem("userId"),
          userIdForStatusUpdate: deleteID,
          userStatus: userStatus,
        },
        data: {
          description: description,
        },
      });
      if (res.data.status === 200) {
        setDescription("");
        setIsLoading(false);
        UserByBH();
        toast.success(res?.data?.message);
        handleCloseDialog();
      }
    } catch (error) {
      handleCloseDialog();
      setIsLoading(false);
    }
  };
  const userDelete = async (value) => {
    setIsLoading(true);
    try {
      const res = await axios({
        method: "DELETE",
        url: ApiConfig.deleteUser,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          location: "",
          ipAddress: "",
          role: Cookies.get("userType"),
          userId: window.localStorage.getItem("userId"),
          userIdToDelete: deleteID,
          username: window.localStorage.getItem("email"),
        },
      });
      if (res.data.status === 200) {
        setIsLoading(false);
        UserByBH();
        handleCloseDialog();
        toast.success("User Deleted Successfully");
      } else {
        handleCloseDialog();
        setIsLoading(false);
      }
    } catch (error) {
      handleCloseDialog();
      setIsLoading(false);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleDateChange = (date) => {
    setfromDate(date);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleToDateChange = (date) => {
    settoDate(date);
  };
  const handleReset = () => {
    setfromDate(null);
    setStatus("");
    settoDate(null);
  };

  useEffect(() => {
    UserByBH();
  }, [searchValue, fromDate, toDate, status, page, pageSize]);

  const handleDescriptionChange = (e) => {
    const inputValue = e.target.value;
    setDescription(inputValue);

    if (inputValue.trim() === "") {
      setErrorMessage("Block reason is required.");
    } else if (inputValue.length > 520) {
      setErrorMessage("Block reason should be 520 characters or fewer.");
    } else {
      setErrorMessage("");
    }
  };

  return (
    <div>
      <PageTitle title="Area Manager Management" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Widget>
            <Grid
              container
              spacing={2}
              style={{ justifyContent: "right", alignItems: "center" }}
            >
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <Typography>Search</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Search by name & email"
                  value={searchValue}
                  onChange={handleInputChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <Typography>From</Typography>

                <div className={classes.forminputDate}>
                  <KeyboardDatePicker
                    className={classes.date}
                    InputProps={{
                      className: classes.TextBox,
                    }}
                    // placeholder="DD/MM/YYYY"
                    InputLabelProps={{ shrink: true }}
                    placeholder="DD/MM/YYYY"
                    format="DD/MM/YYYY"
                    inputVariant="outlined"
                    disableFuture
                    margin="dense"
                    name="dateOfBirth"
                    value={fromDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      style: { marginRight: "-15px" },
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <Typography>To</Typography>

                <div className={classes.forminputDate}>
                  <KeyboardDatePicker
                    className={`${classes.date} textFeilds`}
                    InputProps={{
                      className: classes.TextBox,
                    }}
                    placeholder="DD/MM/YYYY"
                    format="DD/MM/YYYY"
                    inputVariant="outlined"
                    minDate={fromDate ? fromDate : new Date()}
                    disableFuture
                    margin="dense"
                    name="dateOfBirth"
                    value={toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      style: { marginRight: "-15px" },
                    }}
                  />{" "}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <Typography>Status</Typography>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.forminput}
                >
                  <Select
                    margin="dense"
                    style={{}}
                    name="token"
                    className={`${classes.date} textFeilds`}
                    inputProps={{
                      classes: {
                        icon: classes.icon,
                      },
                    }}
                    displayEmpty
                    placeholder="Select user type"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="" style={{ fontSize: "12px" }}>
                      All
                    </MenuItem>
                    <MenuItem value="ACTIVE" style={{ fontSize: "12px" }}>
                      ACTIVE
                    </MenuItem>
                    <MenuItem value="BLOCK" style={{ fontSize: "12px" }}>
                      BLOCKED
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Button
                  className={classes.btn}
                  variant="contained"
                  fullWidth
                  onClick={handleReset}
                >
                  Clear
                </Button>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Button
                  className={classes.btn}
                  variant="contained"
                  fullWidth
                  onClick={() => history.push("/app/add-branch-head")}
                >
                  Add Area Manager
                </Button>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        <Grid item xs={12}>
          {loader ? (
            <CircularProgressWithBackdrop />
          ) : (
            <div id="muiTableData">
              <Tables data={tableData} column={column} size={size} />
            </div>
          )}
        </Grid>
        {/* <Grid item xs={12} align="right">
          <TablePagination
            count={size}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid> */}
        {size > 10 && (
          <Grid item xs={12} align="right">
            <TablePagination
              count={size}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        )}
      </Grid>

      <Dialog open={deleteOpen} onClose={handleCloseDialog}>
        <OuterDiv>
          <Title>Confirmation</Title>

          {userStatus === "BLOCK" && (
            <Box>
              <InputLabel style={{ color: "#000", paddingBottom: "5px" }}>
                Block Reason
              </InputLabel>
              {/* <TextField multiline minRows={5}
                variant="outlined"
                id="textarea"
                fullWidth rows={4} cols={50}
                onChange={(e) => setDescription(e.target.value)}
                inputProps={{ maxLength: 520 }} /> */}
              <TextField
                className={classes.btnYes}
                multiline
                minRows={5}
                variant="outlined"
                id="textarea"
                fullWidth
                rows={4}
                cols={50}
                // inputProps={{ maxLength: 521 }}
                value={description}
                onChange={handleDescriptionChange}
                error={Boolean(errorMessage)}
                helperText={errorMessage}
              />
            </Box>
          )}
          <DialogContent>
            <Para>
              Are you sure you want to
              {userStatus === "BLOCK" ? " Block" : " Unblock"} this User ?
            </Para>
          </DialogContent>

          <BtnDivision>
            <BackBtn
              onClick={() => {
                if (description) {
                  userBlock();
                } else if (userStatus === "ACTIVE") {
                  userBlock();
                  console.log("User is already blocked.");
                  // Optionally add some UI indication or feedback for the user
                } else {
                  console.log("Error: Block reason is required.");
                  setErrorMessage("Block reason is required.");
                }
              }}
            >
              YES
            </BackBtn>
            <BackBtn onClick={() => handleCloseDialog()}>NO</BackBtn>
          </BtnDivision>
        </OuterDiv>
      </Dialog>

      <Dialog open={deleteDialog} onClose={handleCloseDialog}>
        <OuterDiv>
          <Title>Confirmation</Title>
          <DialogContent>
            <Para>Are you sure you want to Delete this User ?</Para>
          </DialogContent>

          <BtnDivision>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <>
                <BackBtn onClick={() => userDelete()}>YES</BackBtn>
                <BackBtn onClick={() => handleCloseDialog()}>NO</BackBtn>
              </>
            )}
          </BtnDivision>
        </OuterDiv>
      </Dialog>
    </div>
  );
}

export default BranchHeadManagement;
